/*Bug #603 - Create a common component for Address fields - Author Jithin Kuriakose on 05Sept2021*/
import {
    InputItem,
    Checkbox,
    Col,
    Row,
    CommonInputLabel,
    Race,
} from "components";
import { getCountryCode, getFormFields } from "shared/utils/formlocalization";

interface Props {
    className?: React.CSSProperties | String;
    preFix: String;
    label?: String;
}

const RaceInput = (props: Props) => {
    const field = getFormFields(getCountryCode(), "race");
    return field ? (
        <Col
            lg={field?.columnSize ? field.columnSize : 6}
            md={field?.columnSize ? field.columnSize : 6}
            sm={12}
        >
            <Row>
                <CommonInputLabel label={props?.label} />

                <Col sm={12} md={12} lg={12}>
                    <InputItem
                        name={
                            props?.preFix
                                ? [props.preFix, field?.key]
                                : field?.key
                        }
                        label={field?.label ? field.label : ""}
                        rules={field?.rules ? field.rules : ""}
                    >
                        <Checkbox.Group options={Race} />
                    </InputItem>
                </Col>
            </Row>
        </Col>
    ) : null;
};

export default RaceInput;

/** End Bug #603 **/
